
import React from 'react'

import { Tabs } from '~components/Tabs'
import CodeSample from './CodeSample'

const PRISM_LANGUAGES = {
  'curl': 'curl',
  'dotnet': 'csharp',
  'c#': 'csharp',
  'cs': 'csharp',
  'java' : 'java',
  'python': 'py',
  'node' : 'js',
  'ios': 'swift',
  'json': 'json',
  'yaml': 'yaml',
  'js': 'js',
  'py': 'py',
  'bash': 'bash',
  'ini': 'ini'
}

const PRIORITIES = Object.keys(PRISM_LANGUAGES)
const byPriority = (a, b) => PRIORITIES.indexOf(a.language) - PRIORITIES.indexOf(b.language)

const TabbedCodeBlocks = ({
  samples
}) => {
  return (
    <div data-role={ 'code-sample' }>
      <Tabs>
        { samples.sort(byPriority).map((sample) => (
          <CodeSample 
            key={sample.id} 
            sample={sample}
          />
        )) }
      </Tabs>      
    </div>
  )
}

export default TabbedCodeBlocks
export { PRISM_LANGUAGES }
